// Incase of active resource there might be a lot of comment replies appearing, but we don't
// want UI to render too often.
export function initLiveCommentsThrottler({ emitTo: emit, timeout, }) {
    let state = { type: 'OPEN' };
    const emitSuspended = () => {
        if (state.type !== 'SUSPEND') {
            return;
        }
        if (state.suspendedMessages.length) {
            emit(state.suspendedMessages);
        }
        state = { type: 'OPEN' };
    };
    return (messages) => {
        if (state.type === 'OPEN') {
            emit(messages);
            state = { type: 'SUSPEND', suspendedMessages: [] };
            setTimeout(emitSuspended, timeout);
        }
        else {
            state.suspendedMessages = [...state.suspendedMessages, ...messages];
        }
    };
}
//# sourceMappingURL=live-comments-throttler.js.map